<template>
  <div class="collapse" :class="{'is-active': active}">
    <div class="collapse-header" @click="toggle">
      <span>{{title}}</span><img src="@/assets/icon-collapse.png"/>
    </div>
    <transition name="down"
      @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave">
      <div v-if="active" class="collapse-content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      selected: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        active: this.selected
      }
    },
    methods: {
      toggle() {
        this.active = !this.active;
      },
      
      beforeEnter(el) {
        el.style.height = '0';
      },
      enter(el) {
        el.style.height = `${el.scrollHeight}px`;
      },
      leave(el) {
        el.style.height = '0';
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/px2rem.scss";
  
  .collapse {
    &.is-active {
      .collapse-header {
        img {
          transform: rotate(90deg);
        }
      }
    }
    
    .collapse-header {
      text-align: center;
      font-size: px2rem(30);
      color: #666;
      img {
        width: px2rem(20);
        margin-left: px2rem(10);
        vertical-align: middle;
      }
    }
    
    .collapse-content {
      overflow: hidden;
    }
    
    .down-enter-active,
    .down-leave-active {
      transition: all .2s;
    }
  }
</style>
  
